import mqtt from 'mqtt'

import pinia from '@/store'
import { useAuthStore } from '@/store/auth'
import { useConfigStore } from '@/store/config'
import { useStatusStore } from '@/store/status'
import sync from '@/sync/service'

const client = mqtt.connect(import.meta.env.VITE_APP_MQTT_URL)

function subscribe(locationId: string) {
  const topic = import.meta.env.VITE_APP_MQTT_TOPIC + '-' + locationId
  const status = useStatusStore(pinia)
  client.subscribe(topic, () => {
    status.updateMqttStatus(true)
  })
  sync.resync()
}

client.on('connect', () => {
  const auth = useAuthStore(pinia)
  const locationId = auth.locationId
  if (locationId) {
    subscribe(locationId)
  }
})

client.on('end', () => {
  const status = useStatusStore(pinia)
  status.updateMqttStatus(false)
})

client.on('offline', () => {
  const status = useStatusStore(pinia)
  status.updateMqttStatus(false)
})

client.on('disconnect', () => {
  const status = useStatusStore(pinia)
  status.updateMqttStatus(false)
})

client.on('message', (_, data: Buffer) => {
  const message = JSON.parse(data.toString())
  const config = useConfigStore(pinia)
  const status = useStatusStore(pinia)

  status.updateMqttStatus(true)

  switch (message.type) {
    case 'event':
      sync.playRemote(message.event)
      break
    case 'configUpdate':
      config.refreshConfig(message.config)
      break
    case 'resync':
      sync.resync()
      break
  }
})

export default {
  subscribe: subscribe,
  isConnected: () => client.connected
}
